import { render, staticRenderFns } from "./PostSroMainHomeNotDeliveredStatus.vue?vue&type=template&id=18f561d0"
import script from "./PostSroMainHomeNotDeliveredStatus.vue?vue&type=script&lang=js"
export * from "./PostSroMainHomeNotDeliveredStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports